import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants, documentationActions } from '../../actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';
const {
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER,
  GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS,
} = DashboardConstants;

function* getAllSubmittedDocumentOfDashboard(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_LOADER });
    const response = yield call(dashboardServices.getDashboardDocument, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_FAILURE, payload: error });
  }
}

function* dashboardDocumentListSaga() {
  yield takeEvery(GET_DASHBOARD_ALL_SUBMITTED_DOCUMENT_REQUEST, getAllSubmittedDocumentOfDashboard);
}

export default dashboardDocumentListSaga;
